import React from 'react';
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/stores/Root';

// This component is coupled to WrappedStripeCheckoutForm, do not use it by itself
const StripeCheckoutForm: React.FC = observer(() => {
  const rootStore = useMst();
  const { cart, configuration } = rootStore;
  const stripe = useStripe();
  const elements = useElements();

  if (!elements || !stripe) {
    return <p>Loading</p>;
  }

  rootStore.setStripeElements(stripe, elements);

  return (
    <PaymentElement
      options={{
        defaultValues: {
          billingDetails: {
            name: `${cart.billingAddress.firstName} ${cart.billingAddress.lastName}`,
            email: cart.customer.emailAddress ?? undefined,
            phone: cart.customer.phoneNumber ?? undefined,
            address: {
              country: configuration.findCountryIsoCode(
                cart.billingAddress.country
              ),
              postal_code: cart.shippingAddress.postalCode ?? undefined,
            },
          },
        },
      }}
    />
  );
});

export default StripeCheckoutForm;
